'use client';

import { c as _c } from "react/compiler-runtime";
import { datadogRum } from '@datadog/browser-rum';
import { usePathname } from 'next/navigation';
import { type PropsWithChildren, useEffect } from 'react';
import { EXPERIMENT_CONFIG } from '../experiments';
type Props = PropsWithChildren<{
  serverSideExperimentDecision: string;
}>;
export function LogStaticExperiments(t0) {
  const $ = _c(7);
  const {
    children,
    serverSideExperimentDecision
  } = t0;
  const pathname = usePathname();
  const staticExperimentName = EXPERIMENT_CONFIG[pathname];
  let t1;
  if ($[0] !== serverSideExperimentDecision || $[1] !== staticExperimentName) {
    t1 = () => {
      if (staticExperimentName) {
        datadogRum.addFeatureFlagEvaluation(staticExperimentName?.replace("-", "_"), serverSideExperimentDecision);
        datadogRum.addAction("Static ABSmartly Bucketing", {
          staticExperimentName
        });
      }
    };
    $[0] = serverSideExperimentDecision;
    $[1] = staticExperimentName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== staticExperimentName) {
    t2 = [staticExperimentName];
    $[3] = staticExperimentName;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== children) {
    t3 = <>{children}</>;
    $[5] = children;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}